import axios from "axios";
import _ from "lodash";
import { canaveral_url, valaquenta_api_url } from "../../api";

export const fetchSession = async (session_id: string) => {
  try {
    const response = await axios.get(`${canaveral_url}/ext-auth/${session_id}`);
    return _.get(response, "data", []);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const saveAuthSessionData = (data: any) => {
  const key = window.btoa("auth_data");
  const encoded_data = window.btoa(JSON.stringify(data));
  window.sessionStorage.setItem(key, encoded_data);
};

export const getAuthSessionData = () => {
  const key = window.btoa("auth_data");
  const encoded_data = window.sessionStorage.getItem(key);
  if (!encoded_data) {
    return null;
  }

  try {
    const decoded_data = window.atob(encoded_data);
    return JSON.parse(decoded_data);
  } catch (error) {
    return null;
  }
};

export const getExtJWTUserData = async ({ jwt, endpoint }) => {
  try {
    const response = await axios.get(endpoint, {
      headers: { Authorization: `Bearer ${jwt}` },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const getSeacretProfileInfo = async ({ endpoint, token }) => {
  const params = new URLSearchParams();
  params.append("action", "innstant");
  params.append("token", token);

  try {
    const response = await axios.post(
      `https://${endpoint}.clubseacret.com/wp-admin/admin-ajax.php`,
      params,
    );

    return _.get(response, "data", {});
  } catch {
    return null;
  }
};

export async function getExtProfileInfo({ token, source_entity, website_api_key }) {
  try {
    const response = await axios.get(`${valaquenta_api_url}/guest-crm/verify-user/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { source_entity, website: website_api_key },
    });

    return response?.data;
  } catch {
    return null;
  }
}
